import React, { FormEvent } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { ServicesContext, useAdminService } from '~/services';
import { UploadGMPIs } from '~/components/Admin';

export interface MaclType {
    id: number;
    name: string;
    patients_count: Number; // eslint-disable-line babel/camelcase
    users_count?: number; // eslint-disable-line babel/camelcase
}
export interface MaclFormProps {
    id: string;
    macl: MaclType;
    onCancel: () => void;
    onSuccess: () => void;
}
export function MaclForm({ id, macl, onCancel, onSuccess }: MaclFormProps) {
    const servicesContext = React.useContext(ServicesContext);
    const { editMacl } = useAdminService();
    const [errors, setErrors] = React.useState<string[]>([]);
    const [loading, setLoading] = React.useState(false);
    const [name, setName] = React.useState(macl.name);
    const [storedFiles, setFiles] = React.useState<DropzoneFileType[]>([]);

    async function handleSubmit(event: FormEvent) {
        event.preventDefault();
        try {
            setLoading(true);
            await editMacl(macl.id, name.trim(), storedFiles);
            if (storedFiles.length > 0) {
                servicesContext.alert.set(
                    'Upload successful. Your MACL results will be emailed upon completion.',
                    'success'
                );
            }
            onSuccess();
        } catch (e) {
            if (!Array.isArray(e?.response)) {
                setErrors(['An upload error occurred']);
            } else {
                setErrors(e.response.map((x: { message: string }) => x.message));
            }
        } finally {
            setLoading(false);
        }
    }

    return (
        <form id={id} onSubmit={handleSubmit}>
            <div className="row">
                <div className="col-12">
                    <label htmlFor="name" className="col-form-label">
                        Name
                    </label>
                    <input
                        className="form-control"
                        disabled={loading}
                        id="name"
                        onChange={(e) => setName(e.target.value)}
                        required
                        value={name}
                        type="text"
                    />
                </div>
            </div>
            <div className="row mt-3 mb-2">
                <div className="col-12">
                    <div>Members: {`${macl.patients_count}`}</div>
                    <div>Assigned Users: {macl.users_count}</div>
                </div>
            </div>
            <UploadGMPIs
                errors={errors}
                setErrors={setErrors}
                loading={loading}
                setLoading={setLoading}
                storedFiles={storedFiles}
                setFiles={setFiles}
            />
            <div className="mt-2">
                <Button
                    type="submit"
                    variant="primary"
                    className="me-1"
                    disabled={loading || name.trim().length === 0}
                >
                    {loading && (
                        <Spinner
                            animation="border"
                            variant="light"
                            size="sm"
                            role="status"
                            className="me-1"
                        />
                    )}
                    Submit
                </Button>
                <Button onClick={onCancel} variant="secondary" disabled={loading}>
                    Cancel
                </Button>
            </div>
        </form>
    );
}
